import React from 'react';
import {Portlet, PortletHeader} from "../../../../components/Portlet";
import AirlineForm from "../components/airlineForm";
import {connect} from "react-redux";
import {CreateItem} from "../../../../redux/actions/base";
import {AirlineListRoute} from "../../../routesConstants";
import {Helmet} from "react-helmet";


const AirlineCreatePage = ({CreateItem}) =>{

  const callback = (values, cb)=>{
    CreateItem('/api/air/airlines', values, cb, AirlineListRoute )
  }
  return <>
    <Helmet>
      <title>Авиакомпания</title>
    </Helmet>
    <div className={"row"}>
      <div className="col-xl-6">
        <Portlet>
          <PortletHeader title={"Создание авиакомпании"}/>
          <AirlineForm onSubmit={callback}/>
        </Portlet>
      </div>
    </div>
  </>
}

export default connect(null, {CreateItem})(AirlineCreatePage)
